import { IPagedFirmaQuery, PagedFirmaQueryField } from "../interfaces/firma";
import { IPagedKursusQuery, PagedKursusQueryField } from "../interfaces/kursus";
import {
  IPagedPersonsQuery,
  PagedPersonsQueryField,
} from "../interfaces/personer";
import { PagedLinjeQuery, PagedLinjeQueryField } from "../interfaces/linje";

/**
 * Converts and formats type fields to a graphql formatted string.
 * @param fields type fields for the provided interface/type.
 * @returns a graphql ready string containing the requested fields.
 */
export function getFields<T>(
  fields?: T | T[] | undefined,
  omitId?: boolean,
): string {
  if (!fields) {
    return omitId ? "" : "id";
  }

  if (Array.isArray(fields)) {
    return `${omitId ? "" : "id"}
      ${fields
        .map((field) => {
          if ((field as string).includes(".")) {
            return unwrapStringForGraph(field as string);
          } else {
            return `${field}`;
          }
        })
        .join("\n")}
    `;
  }

  return fields as unknown as string;
}

/**
 * Unwraps type as string for graphql
 * @param string the string to "unwrap" - the string MUST contain a "." (dot)
 * @returns a new "formatted" string for GraphQL
 */
function unwrapStringForGraph(string: string): string {
  const stringArray = string.split(".");

  const unwrapped = stringArray.reduce((acc, value, index, array) => {
    return `${acc}{\n  ${value} ${
      index === array.length - 1 ? "\n}".repeat(array.length - 1) : ""
    }`;
  });

  return unwrapped;
}

export function getOrderByWithSecondOrder(
  query:
    IPagedPersonsQuery | IPagedFirmaQuery | IPagedKursusQuery | PagedLinjeQuery,
  secondOrderKey:
    | PagedPersonsQueryField
    | PagedFirmaQueryField
    | PagedKursusQueryField
    | PagedLinjeQueryField,
  secondOrderDirection: "ASC" | "DESC",
) {
  let orderBy = "";

  if (query?.order?.orderKey && query?.order?.orderDirection) {
    const orderDirection = query?.order?.orderDirection;
    const orderKey = query?.order?.orderKey;
    const splitKeys = orderKey.split(".");

    if (splitKeys.length === 1) {
      orderBy = `order: [{ ${orderKey} : ${orderDirection}} , { ${secondOrderKey}: ${secondOrderDirection} }]`;
    } else {
      orderBy = `order: [{ ${splitKeys.reduce((acc, value, index, array) => {
        return `${acc}: { ${
          index === array.length - 1
            ? `${value}: ${orderDirection}`.concat(
                " }".repeat(array.length - 1),
              )
            : value
        }`;
      })} } , { ${secondOrderKey}: ${secondOrderDirection} }]`;
    }
  }

  return orderBy;
}
